<script>
export default {
    data() {
        return {
            legalIdentities: []
        }
    },
    methods: {
        legalIdentityChange({identity, index}) {
            this.legalIdentities[index] = identity;
        },
        addLegalIdentity(identity) {
            this.legalIdentities.push(identity);
        },
        removeLegalIdentity(params) {
            this.legalIdentities.splice(params.index, 1);
        },
    }
}
</script>
